/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminRoleProvider_wrapper_nsWCM"};